import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const CreateOrgPageContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/CreateOrgPageContainer" */
      './CreateOrgPageContainer.dynamic'
    ),
  loading: LoadableLoadingSection,
});
